import { FunctionComponent } from 'react'
import { ReactComponent as Bloody } from '../Icons/blood.svg'
import { ReactComponent as SortedOut } from '../Icons/sorted_out.svg'
import { ReactComponent as Useless } from '../Icons/useless.svg'
import { ReactComponent as Dirty } from '../Icons/dirty.svg'

type OwnProps = {
  type: string
}

type Props = OwnProps

export const EggIcon: FunctionComponent<Props> = ({ type }) => {
  return (
    <>
      {type === 'Knäckta' && (
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1660:867)">
              <path
                d="M22.0007 12.2492L19.7833 14.1334C19.5181 14.3587 19.1281 14.3561 18.8659 14.1275L15.664 11.3353L12.4621 14.1275C12.3297 14.243 12.1648 14.3007 11.9999 14.3007C11.8351 14.3007 11.6703 14.243 11.5379 14.1275L8.33591 11.3353L5.13406 14.1275C4.8718 14.3562 4.4818 14.3587 4.21667 14.1334L1.99925 12.2492C1.92275 12.8116 1.88281 13.3592 1.88281 13.8828C1.88281 16.5852 2.93516 19.1259 4.84606 21.0368C6.75688 22.9477 9.29759 24 11.9999 24C14.7023 24 17.243 22.9477 19.1539 21.0368C21.0647 19.1259 22.1172 16.5852 22.1172 13.8828C22.1172 13.3592 22.0771 12.8116 22.0007 12.2492Z"
                fill="#EDA10D"
              />
              <path
                d="M19.2481 4.96252C18.3005 3.49134 17.2352 2.31469 16.0815 1.46513C14.7612 0.492938 13.3881 0 12.0001 0C10.6122 0 9.23904 0.492938 7.91885 1.46513C6.76525 2.31469 5.69983 3.49139 4.7523 4.96252C3.62927 6.70612 2.77671 8.71945 2.30322 10.662L4.66619 12.6698L7.87399 9.87248C8.13879 9.64148 8.53347 9.64153 8.79827 9.87244L12.0002 12.6646L15.2021 9.87244C15.4669 9.64144 15.8615 9.64148 16.1264 9.87248L19.3342 12.6698L21.6972 10.6619C21.2236 8.71941 20.3711 6.70608 19.2481 4.96252Z"
                fill="#EDA10D"
              />
            </g>
            <defs>
              <clipPath id="clip0_1660:867">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      )}
      {type === 'Blodiga' && <Bloody />}
      {type === 'Smutsiga' && <Dirty />}
      {type === 'Odugliga' && <Useless />}
      {type === 'Frånsorterade' && <SortedOut />}
    </>
  )
}
